import React, { useState } from 'react'
import { Link, graphql } from 'gatsby'

import useErudusStats from '../../hooks/useErudusStats'

import ArrowRightSVG from './../../assets/svg/arrow-right.svg'

const CompanyTabs = ({ companiesData }) => {
  const [activeTab, setActiveTab] = useState(companiesData.defaultTab)

  const activeTabClass = (tab) => {
    return activeTab === tab ? 'is-active' : null
  }

  const {
    manufacturerCount,
    wholesalerCount,
    catererRetailerCount,
  } = useErudusStats()

  const getValue = (tab) => {
    switch (tab.border) {
      case 'isManufacturers':
        return manufacturerCount
      case 'isWholesalers':
        return wholesalerCount
      case 'isRetailers':
      case 'isCaterers':
        return catererRetailerCount
      default:
        return tab.value
    }
  }

  return (
    <section className="c-section c-section--forCompanies">
      <div className="c-section__outer container">
        <div className="c-section__inner">
          <div className="c-forCompanies">
            <div className="c-forCompanies__header mb-5">
              <h2>{companiesData.title}</h2>
            </div>

            <ul id="forCompaniesTabs" className="c-forCompaniesTabs row">
              <li
                className={`c-forCompaniesTab ${companiesData.one.tab.border} col-12 col-md-4`}
              >
                <div
                  className={`c-forCompaniesTab__link ${activeTabClass('one')}`}
                  onClick={() => setActiveTab('one')}
                >
                  <div className="c-forCompaniesTab__image">
                    {companiesData.one.tab.icons.map((icon, i) => (
                      <img
                        key={`tab_one_${i}`}
                        src={`/images/icons/${icon.icon}.svg`}
                        className={`img-fluid ${icon.icon}`}
                        alt={icon.alt}
                      />
                    ))}
                  </div>
                  <p>
                    <strong>{getValue(companiesData.one.tab)}</strong>
                    {companiesData.one.tab.label}
                  </p>
                </div>
              </li>

              <li
                className={`c-forCompaniesTab ${companiesData.two.tab.border} col-12 col-md-4`}
              >
                <div
                  className={`c-forCompaniesTab__link ${activeTabClass('two')}`}
                  onClick={() => setActiveTab('two')}
                >
                  <div className="c-forCompaniesTab__image">
                    {companiesData.two.tab.icons.map((icon, i) => (
                      <img
                        key={`tab_two_${icon.i}`}
                        src={`/images/icons/${icon.icon}.svg`}
                        className={`img-fluid ${icon.icon}`}
                        alt={icon.alt}
                      />
                    ))}
                  </div>
                  <p>
                    <strong>{getValue(companiesData.two.tab)}</strong>
                    {companiesData.two.tab.label}
                  </p>
                </div>
              </li>

              <li
                className={`c-forCompaniesTab ${companiesData.three.tab.border} col-12 col-md-4`}
              >
                <div
                  className={`c-forCompaniesTab__link ${activeTabClass(
                    'three'
                  )}`}
                  onClick={() => setActiveTab('three')}
                >
                  <div className="c-forCompaniesTab__image">
                    {companiesData.three.tab.icons.map((icon, i) => (
                      <img
                        key={`tab_three_${i}`}
                        src={`/images/icons/${icon.icon}.svg`}
                        className={`img-fluid ${icon.icon}`}
                        alt={icon.alt}
                      />
                    ))}
                  </div>
                  <p>
                    <strong>{getValue(companiesData.three.tab)}</strong>
                    {companiesData.three.tab.label}
                  </p>
                </div>
              </li>
            </ul>

            <div
              className="c-forCompaniesList"
              style={{ display: activeTab === 'one' ? 'block' : 'none' }}
            >
              <div className="row mb-5">
                {companiesData.one.list.map((list) => (
                  <div key={list.name} className="col-6 col-lg-3 mb-4">
                    <div className="c-forCompaniesListItem">
                      <img
                        className="img-fluid"
                        src={list.image}
                        title={list.name}
                        alt={list.name}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="c-forCompaniesList"
              style={{ display: activeTab === 'two' ? 'block' : 'none' }}
            >
              <div className="row mb-5">
                {companiesData.two.list.map((list) => (
                  <div key={list.name} className="col-6 col-lg-3 mb-4">
                    <div className="c-forCompaniesListItem">
                      <img
                        className="img-fluid"
                        src={list.image}
                        title={list.name}
                        alt={list.name}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div
              className="c-forCompaniesList"
              style={{ display: activeTab === 'three' ? 'block' : 'none' }}
            >
              <div className="row mb-5">
                {companiesData.three.list.map((list) => (
                  <div key={list.name} className="col-6 col-lg-3 mb-4">
                    <div className="c-forCompaniesListItem">
                      <img
                        className="img-fluid"
                        src={list.image}
                        title={list.name}
                        alt={list.name}
                      />
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <Link
                  to="/whos-using-erudus"
                  className="c-button c-button--secondary mb-4"
                >
                  <ArrowRightSVG className="c-icon mr-2" />
                  See a full list of all Erudus users
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CompanyTabs

export const FragmentQuery = graphql`
  fragment CompanyTabsFragment on MarkdownRemarkFrontmatter {
    companies {
      defaultTab
      title
      one {
        tab {
          label
          value
          border
          icons {
            icon
            alt
          }
        }
        list {
          name
          image
        }
      }
      two {
        tab {
          label
          value
          border
          icons {
            icon
            alt
          }
        }
        list {
          name
          image
        }
      }
      three {
        tab {
          label
          value
          border
          icons {
            icon
            alt
          }
        }
        list {
          name
          image
        }
      }
    }
  }
`
